module.exports = __webpack_public_path__ + "static/img/about2.4a5056a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about2.png
// module id = G4/g
// module chunks = 0